module.exports = __webpack_public_path__ + "img/header.a8d31d60.png";